/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AddressViewModel } from './AddressViewModel';
import {
    AddressViewModelFromJSON,
    AddressViewModelFromJSONTyped,
    AddressViewModelToJSON,
} from './AddressViewModel';
import type { ContactDetailsViewModel } from './ContactDetailsViewModel';
import {
    ContactDetailsViewModelFromJSON,
    ContactDetailsViewModelFromJSONTyped,
    ContactDetailsViewModelToJSON,
} from './ContactDetailsViewModel';
import type { IAPRELATIONSHIPTYPE } from './IAPRELATIONSHIPTYPE';
import {
    IAPRELATIONSHIPTYPEFromJSON,
    IAPRELATIONSHIPTYPEFromJSONTyped,
    IAPRELATIONSHIPTYPEToJSON,
} from './IAPRELATIONSHIPTYPE';
import type { IndividualPartyDetailsViewModel } from './IndividualPartyDetailsViewModel';
import {
    IndividualPartyDetailsViewModelFromJSON,
    IndividualPartyDetailsViewModelFromJSONTyped,
    IndividualPartyDetailsViewModelToJSON,
} from './IndividualPartyDetailsViewModel';
import type { ThirdPartyIndividualEmploymentAndTax } from './ThirdPartyIndividualEmploymentAndTax';
import {
    ThirdPartyIndividualEmploymentAndTaxFromJSON,
    ThirdPartyIndividualEmploymentAndTaxFromJSONTyped,
    ThirdPartyIndividualEmploymentAndTaxToJSON,
} from './ThirdPartyIndividualEmploymentAndTax';

/**
 * 
 * @export
 * @interface IndividualThirdPartyViewModel
 */
export interface IndividualThirdPartyViewModel {
    /**
     * 
     * @type {IAPRELATIONSHIPTYPE}
     * @memberof IndividualThirdPartyViewModel
     */
    relationshipTypeId?: IAPRELATIONSHIPTYPE;
    /**
     * 
     * @type {IndividualPartyDetailsViewModel}
     * @memberof IndividualThirdPartyViewModel
     */
    individualDetails?: IndividualPartyDetailsViewModel;
    /**
     * 
     * @type {ThirdPartyIndividualEmploymentAndTax}
     * @memberof IndividualThirdPartyViewModel
     */
    employmentAndTax?: ThirdPartyIndividualEmploymentAndTax;
    /**
     * 
     * @type {ContactDetailsViewModel}
     * @memberof IndividualThirdPartyViewModel
     */
    contactInformation?: ContactDetailsViewModel;
    /**
     * 
     * @type {AddressViewModel}
     * @memberof IndividualThirdPartyViewModel
     */
    physicalAddress?: AddressViewModel;
}

/**
 * Check if a given object implements the IndividualThirdPartyViewModel interface.
 */
export function instanceOfIndividualThirdPartyViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function IndividualThirdPartyViewModelFromJSON(json: any): IndividualThirdPartyViewModel {
    return IndividualThirdPartyViewModelFromJSONTyped(json, false);
}

export function IndividualThirdPartyViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): IndividualThirdPartyViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'relationshipTypeId': !exists(json, 'RelationshipTypeId') ? undefined : IAPRELATIONSHIPTYPEFromJSON(json['RelationshipTypeId']),
        'individualDetails': !exists(json, 'IndividualDetails') ? undefined : IndividualPartyDetailsViewModelFromJSON(json['IndividualDetails']),
        'employmentAndTax': !exists(json, 'EmploymentAndTax') ? undefined : ThirdPartyIndividualEmploymentAndTaxFromJSON(json['EmploymentAndTax']),
        'contactInformation': !exists(json, 'ContactInformation') ? undefined : ContactDetailsViewModelFromJSON(json['ContactInformation']),
        'physicalAddress': !exists(json, 'PhysicalAddress') ? undefined : AddressViewModelFromJSON(json['PhysicalAddress']),
    };
}

export function IndividualThirdPartyViewModelToJSON(value?: IndividualThirdPartyViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'RelationshipTypeId': IAPRELATIONSHIPTYPEToJSON(value.relationshipTypeId),
        'IndividualDetails': IndividualPartyDetailsViewModelToJSON(value.individualDetails),
        'EmploymentAndTax': ThirdPartyIndividualEmploymentAndTaxToJSON(value.employmentAndTax),
        'ContactInformation': ContactDetailsViewModelToJSON(value.contactInformation),
        'PhysicalAddress': AddressViewModelToJSON(value.physicalAddress),
    };
}

